import BenVerifyScreen from "./BenVerifyScreen";

export default BenVerifyScreen;
